import { BASE_URL } from '../config/Config';

export const RES_STATUS_OK = 'ok';

class RestfulManager {
    getAccessToken = async (json) => {
        return await this._post(undefined, '/accesstoken', json);
    };
    
    getCars = async (accessToken) => {
        return await this._get(accessToken, '/cars');
    };

    getCarByCarCode = async (accessToken, carCode) => {
        return await this._get(accessToken, '/cars/carCode/' + carCode);
    };

    updateCarPowering = async (accessToken, json) => {
        return await this._patch(accessToken, '/cars/powering', json);
    };

    updateCarDeviceId = async (accessToken, json) => {
        return await this._patch(accessToken, '/cars/deviceId', json);
    };

    getLatestCarPoss = async (accessToken) => {
        return await this._get(accessToken, '/carPoss/latest');
    };

    getCarPosByCarCode = async (accessToken, carCode) => {
        return await this._get(accessToken, '/carPoss/carCode/' + carCode);
    };

    getCarPossByRouteCode = async (accessToken, routeCode) => {
        return await this._get(accessToken, '/carPoss/routeCode/' + routeCode);
    };

    getEnergyConsumptions = async (accessToken) => {
        return await this._get(accessToken, '/cars/energyConsumptions');
    };

    getAvailableDevices = async (accessToken) => {
        return await this._get(accessToken, '/devices/available');
    };

    getDevices = async (accessToken) => {
        return await this._get(accessToken, '/devices');
    };

    getDeviceByDeviceId = async (accessToken, deviceId) => {
        return await this._get(accessToken, '/devices/deviceId/' + deviceId);
    };

    getFaults = async (accessToken, query) => {
        return await this._get(accessToken, '/faults' + query);
    };

    getFaultCsv = async (accessToken, query) => {
        return await this._get(accessToken, '/faults/csv' + query);
    };

    getPacketCsv = async (accessToken, query) => {
        return await this._get(accessToken, '/packet/csv' + query);
    };

    getPacketArchivedCsv = async (accessToken, query) => {
        return await this._download(accessToken, '/packet/csv/archived' + query);
    };

    getLatestPacketByCarCode = async (accessToken, carCode) => {
        return await this._get(accessToken, '/packet/latest/carCode/' + carCode);
    };

    getRouteCodes = async (accessToken) => {
        return await this._get(accessToken, '/routes/routeCodes');
    };

    getRouteStations = async (accessToken) => {
        return await this._get(accessToken, '/routeStations');
    }

    getRouteStationsByRouteCode = async (accessToken, routeCode) => {
        return await this._get(accessToken, '/routeStations/routeCode/' + routeCode);
    }

    getRouteStationsByRouteCodeAndDestStationCode = async (accessToken, routeCode, destStationCode) => {
        return await this._get(accessToken, '/routeStations/routeCode/' + routeCode + '/destStationCode/' + destStationCode);
    }

    getStations = async (accessToken) => {
        return await this._get(accessToken, '/stations');
    };
    
    changePassword = async (accessToken, json) => {
        return await this._patch(accessToken, '/users', json);
    };

    getCarSummaries = async (accessToken) => {
        return await this._get(accessToken, '/cars/summaries');
    };

    _download = async (accessToken, url) => {
        const headers = {
            'jwt': accessToken
        };

        const res = await fetch(BASE_URL + url, {
            method: 'GET',
            headers: headers
        });

        return res;
    };

    _get = async (accessToken, url) => {
        const headers = {
            'Content-Type': 'application/json',
            'jwt': accessToken
        };

        const res = await fetch(BASE_URL + url, {
            method: 'GET',
            headers: headers
        });

        return res;
    };

    _post = async (accessToken, url, json) => {
        const headers = {
            'Content-Type': 'application/json',
            'jwt': accessToken
        };

        const res = await fetch(BASE_URL + url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(json)
        });

        return res;
    };

    _put = async (accessToken, url, json) => {
        const headers = {
            'Content-Type': 'application/json',
            'jwt': accessToken
        };

        const res = await fetch(BASE_URL + url, {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(json)
        });

        return res;
    };

    _patch = async (accessToken, url, json) => {
        const headers = {
            'Content-Type': 'application/json',
            'jwt': accessToken
        };

        const res = await fetch(BASE_URL + url, {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(json)
        });

        return res;
    };

    _delete = async (accessToken, url, json) => {
        const headers = {
            'Content-Type': 'application/json',
            'jwt': accessToken
        };

        const res = await fetch(BASE_URL + url, {
            method: 'DELETE',
            headers: headers,
            body: JSON.stringify(json)
        });

        return res;
    };
};

export default RestfulManager;